import React from 'react';
import logo from './logo.svg';
import './App.css';
import Random from './random';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        {/* <p>Hello World Testing!12345789</p>
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          Edit <code>src/App.js</code> and save to reload.
        </p>
        <a
          className="App-link"
          href="https://reactjs.org"
          target="_blank"
          rel="noopener noreferrer"
        >
          Learn React
        </a> */}
        <Random />
      </header>
    </div>
  );
}

export default App;
